import React, { useState } from "react";
import {
  validateOutreachLogin,
  setOutreachSession,
} from "../../lib/outreachMvpCredentials";
import "../../AdminLogin.css";

export default function OutreachLogin({ onLoginSuccess }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleLogin = (e) => {
    e.preventDefault();
    setError("");
    setIsLoading(true);

    const session = validateOutreachLogin(email, password);
    if (!session) {
      setError("Invalid email or password.");
      setIsLoading(false);
      return;
    }

    setOutreachSession(session.email);
    onLoginSuccess(session);
    setIsLoading(false);
  };

  return (
    <div className="admin-login-container">
      <div className="admin-login-box">
        <h1>BTUI Outreach</h1>
        <p>Sign in with your outreach account</p>

        <form onSubmit={handleLogin}>
          <div className="form-group">
            <label>Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="your.email@gmail.com"
              required
              autoComplete="username"
            />
          </div>

          <div className="form-group">
            <label>Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter password"
              required
              autoComplete="current-password"
            />
          </div>

          {error && <div className="error-message">{error}</div>}

          <button type="submit" disabled={isLoading} className="login-btn">
            {isLoading ? "Signing in..." : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
}
